import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProgressService {
  private notificationChange: Subject<Object> = new Subject<Object>();
  public readonly loading$ = this.notificationChange.asObservable();
  ChangeProgressStatus(status: boolean) {
    this.notificationChange.next(status);
  }
}

